/*
 * This script allows us to better discover if safari has entered print mode
 */

const onPrint = (type, match) => (window, cb) => {
    let called = false,
        query,
        queryFn;

    const print = () => {
        if (called) return;
        called = true;
        cb();
    };

    const unsubscribe = () => {
        if (queryFn) query.removeListener(queryFn);
        window.removeEventListener(type + 'print', print, false);
    };

    if (window.matchMedia) {
        queryFn = (query) => {
            if (query.matches === match) print();
        };
        query = window.matchMedia('print');
        query.addListener(queryFn);
    } else {
        window.addEventListener(type + 'print', print, false);
    }

    return unsubscribe;
};

module.exports = {
    before: onPrint('before', true),
    after: onPrint('after', false),
    onPrint: onPrint,
};
